import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const leaveAdminApi = factory.get("leaveAdmin");

const initialState = {
  searchBody: {},
  // The approve / reject dialog: `data` is the row being reviewed and
  // `kind` is the button that opened it ("approved" | "rejected").
  approve: {
    dialog: false,
    data: null,
    kind: null,
  },
  leaves: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const leaveAdminSlice = createSlice({
  name: "leaveAdmin",
  initialState,
  reducers: {
    setApproveDialog: (state, { payload }) => {
      state.approve.dialog = !state.approve.dialog;
      state.approve.data = payload?.data ?? null;
      state.approve.kind = payload?.kind ?? null;
    },
    setDataTable: (state, { payload }) => {
      state.leaves.data = payload.data.data ?? [];
      state.leaves.total = payload.data.total ?? 0;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const { setApproveDialog, setDataTable, setLoading, setSearchBody } =
  leaveAdminSlice.actions;

export default leaveAdminSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("leaves"));
    const res = await leaveAdminApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("leaves"));
  } catch (err) {
    dispatch(setLoading("leaves"));
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const approve = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await leaveAdminApi.approve(id, data);
    dispatch(
      showNotification({
        message: "تم تدقيق الطلب بنجاح",
        type: "success",
      }),
    );
    dispatch(setApproveDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const LeaveAdmin = {
  getAll,
  approve,
};
